import React from "react";
import gql from "graphql-tag";
import { Box } from "@atoms";
import { FundsPageWithdrawalsChart } from "../FundsPageWithdrawalsChart";
import { FundsPageWithdrawalsLegend } from "../FundsPageWithdrawalsLegend";
import { FundsPageWithdrawalsButton } from "../FundsPageWithdrawalsButton";
import { FundsPageWithdrawalsList } from "../FundsPageWithdrawalsList";
import {
  FundsPageWithdrawalsFragment,
  FundsPageWithdrawalsFragment_payments,
} from "./__generated__/FundsPageWithdrawalsFragment";

// == Types ================================================================

interface IProps {
  campaign: FundsPageWithdrawalsFragment;
  withdrawalsList: FundsPageWithdrawalsFragment_payments;
}

// == Constants ============================================================

FundsPageWithdrawals.fragments = gql`
  fragment FundsPageWithdrawalsFragment on Campaign {
    id
    name
    hasBeneficiary
    isViewerOwner @include(if: $hasCurrentUser)
    ...FundsPageWithdrawalsChartFragment
    ...FundsPageWithdrawalsLegendFragment
    ...FundsPageWithdrawalsListFragment
    ...FundsPageWithdrawalsButtonFragment
  }
  ${FundsPageWithdrawalsChart.fragments}
  ${FundsPageWithdrawalsLegend.fragments}
  ${FundsPageWithdrawalsList.fragments}
  ${FundsPageWithdrawalsButton.fragments}
`;

// == Component ============================================================

export default function FundsPageWithdrawals({ campaign, withdrawalsList }: IProps) {
  return (
    <Box bg="lightBlueBg">
      <FundsPageWithdrawalsChart campaign={campaign} />
      <FundsPageWithdrawalsLegend campaign={campaign} />
      <FundsPageWithdrawalsButton campaign={campaign} />
      <FundsPageWithdrawalsList withdrawalsList={withdrawalsList} />
    </Box>
  );
}

// == Styles ===============================================================
